import {
  CurrencyCode,
  EnergySource,
  HvacArea,
  HvacGroup,
  ProjectEvaluation,
  ProjectHvac,
  ProjectParticipants,
  ProjectReport,
} from '@belimo-retrofit-portal/logic';
import { DECIMAL_ZERO } from 'src/modules/common/constants/decimal';

export const PROJECT_VERSION = '2025.3.0';

export const PROJECT_CURRENCY_DEFAULT_DATA: CurrencyCode = 'EUR';

export const PROJECT_REPORT_DEFAULT_DATA: ProjectReport = {
  cover: {
    creationDate: null,
    showBuildingInfo: true,
  },
  energy: {
    enabled: true,
    showHeating: false,
    showCooling: false,
    showVentilation: false,
    showComments: false,
  },
  hvac: [
    {
      enabled: true,
      group: HvacGroup.EMISSION,
      showSchemas: true,
      showDetails: true,
      showComments: true,
      showAreas: {
        [HvacArea.HEATING]: true,
        [HvacArea.COOLING]: true,
        [HvacArea.VENTILATION]: true,
      },
    },
    {
      enabled: true,
      group: HvacGroup.DISTRIBUTION,
      showSchemas: false,
      showDetails: true,
      showComments: true,
      showAreas: {
        [HvacArea.HEATING]: true,
        [HvacArea.COOLING]: true,
        [HvacArea.VENTILATION]: false,
      },
    },
    {
      enabled: true,
      group: HvacGroup.AIR_HANDLER,
      showSchemas: false,
      showDetails: true,
      showComments: true,
      showAreas: {
        [HvacArea.HEATING]: false,
        [HvacArea.COOLING]: false,
        [HvacArea.VENTILATION]: true,
      },
    },
    {
      enabled: true,
      group: HvacGroup.GENERATION,
      showSchemas: false,
      showDetails: true,
      showComments: true,
      showAreas: {
        [HvacArea.HEATING]: true,
        [HvacArea.COOLING]: true,
        [HvacArea.VENTILATION]: false,
      },
    },
  ],
  savings: {
    enabled: true,
    showOverallEfficiency: true,
    showPerAreaEfficiency: true,
    showPotentialSavings: true,
  },
  evaluation: {
    enabled: true,
    showInitialInvestment: true,
    showAnnualSavings: true,
    showInvestmentPerCarbonSavings: true,
  },
  evaluationCharts: {
    enabled: true,
    showReturnOnInvestment: true,
    showInternalRateOfReturn: true,
    showAnnualCarbonEmmission: true,
    showBreakEvenPoint: true,
  },
  appendix: {
    enabled: true,
    files: [],
  },
};

export const PROJECT_PARTICIPANTS_DEFAULT_DATA: ProjectParticipants = {
  author: '',
  consutlingEngineer: '',
  productManager: '',
  propertyManager: '',
};

export const PROJECT_HVAC_DEFAULT_DATA: ProjectHvac = {
  comment: '',
  prices: {
    [EnergySource.ELECTRICITY]: null,
    [EnergySource.GAS]: null,

    [EnergySource.HEATING_DISTRICT]: null,
    [EnergySource.HEATING_OIL]: null,
    [EnergySource.HEATING_OTHER]: null,

    [EnergySource.COOLING_DISTRICT]: null,
    [EnergySource.COOLING_OTHER]: null,
  },
  areas: {
    [HvacArea.HEATING]: {
      enabled: false,
      thermal: {
        energySource: EnergySource.ELECTRICITY,
        annualEnergyUse: null,
        carbonIntensity: null,
      },
      electrical: {
        energySource: EnergySource.ELECTRICITY,
        annualEnergyUse: null,
        carbonIntensity: null,
      },
    },
    [HvacArea.COOLING]: {
      enabled: false,
      thermal: {
        energySource: EnergySource.ELECTRICITY,
        annualEnergyUse: null,
        carbonIntensity: null,
      },
      electrical: {
        energySource: EnergySource.ELECTRICITY,
        annualEnergyUse: null,
        carbonIntensity: null,
      },
    },
    [HvacArea.VENTILATION]: {
      enabled: false,
      thermal: {
        energySource: EnergySource.ELECTRICITY,
        annualEnergyUse: DECIMAL_ZERO,
        carbonIntensity: null,
      },
      electrical: {
        energySource: EnergySource.ELECTRICITY,
        annualEnergyUse: null,
        carbonIntensity: null,
      },
    },
  },
  groups: [
    {
      group: HvacGroup.EMISSION,
      title: '',
      annotations: {
        actual: {},
        future: {},
      },
      areas: [
        {
          area: HvacArea.HEATING,
          visible: true,
          comment: '',
          sections: [],
        },
        {
          area: HvacArea.COOLING,
          visible: true,
          comment: '',
          sections: [],
        },
        {
          area: HvacArea.VENTILATION,
          visible: true,
          comment: '',
          sections: [],
        },
      ],
    },
    {
      group: HvacGroup.DISTRIBUTION,
      title: '',
      annotations: {
        actual: {},
        future: {},
      },
      areas: [
        {
          area: HvacArea.HEATING,
          visible: true,
          comment: '',
          sections: [],
        },
        {
          area: HvacArea.COOLING,
          visible: true,
          comment: '',
          sections: [],
        },
      ],
    },
    {
      group: HvacGroup.GENERATION,
      title: '',
      annotations: {
        actual: {},
        future: {},
      },
      areas: [
        {
          area: HvacArea.HEATING,
          visible: true,
          comment: '',
          sections: [],
        },
        {
          area: HvacArea.COOLING,
          visible: true,
          comment: '',
          sections: [],
        },
      ],
    },
    {
      group: HvacGroup.AIR_HANDLER,
      title: '',
      annotations: {
        actual: {},
        future: {},
      },
      areas: [
        {
          area: HvacArea.VENTILATION,
          visible: true,
          comment: '',
          sections: [],
        },
      ],
    },
  ],
};

export const PROJECT_EVALUATION_DEFAULT_DATA: ProjectEvaluation = {
  investmentAmount: null,
  carbonEmissionPrice: null,
  proposalDescription: '',
};
